import React from 'react';
import { Compass } from '@/utils/icons';

interface TourSkipConfirmProps {
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * Confirm before opting out of all auto-start tours. Mentions the sidebar
 * Tutorials launcher so users know they can come back later.
 */
const TourSkipConfirm: React.FC<TourSkipConfirmProps> = ({ onConfirm, onCancel }) => {
  return (
    <div
      className="fixed inset-0 flex items-center justify-center p-4"
      style={{ zIndex: 1100, animation: 'fadeIn 0.2s ease' }}
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="tour-skip-title"
      aria-describedby="tour-skip-desc"
    >
      {/* Sit above the tour dimmer; clicking the scrim cancels (keeps touring). */}
      <button
        type="button"
        className="absolute inset-0"
        style={{ backgroundColor: 'var(--modal-backdrop)' }}
        aria-label="Keep touring"
        onClick={onCancel}
      />
      <div
        className="cgm-card cgm-modal-panel relative p-6 w-full max-w-md"
        style={{ zIndex: 1101, transition: 'none', animation: 'fadeIn 0.2s ease' }}
      >
        <h3 id="tour-skip-title" className="text-lg font-semibold cgm-text-primary pr-2">
          Skip all tours?
        </h3>
        <p id="tour-skip-desc" className="cgm-text-secondary text-sm mt-2 leading-relaxed">
          This closes the current walkthrough and stops the rest from auto-starting.
          You can replay any tutorial later from{' '}
          <span className="inline-flex items-center gap-1 font-medium cgm-text-primary">
            <Compass className="w-3.5 h-3.5" aria-hidden />
            Tutorials
          </span>{' '}
          in the sidebar.
        </p>
        <div className="flex items-center justify-end gap-2 mt-6">
          <button type="button" onClick={onCancel} className="cgm-button-flat py-2 px-4 text-sm">
            Keep touring
          </button>
          <button type="button" onClick={onConfirm} className="cgm-button py-2 px-4 text-sm">
            Skip all tours
          </button>
        </div>
      </div>
    </div>
  );
};

export default TourSkipConfirm;
